import { Component, OnInit, Input } from '@angular/core';
import { ITabComponent, CrawfordSnackbarService } from 'crawford-shell';

@Component({
  selector: 'app-claim-media',
  templateUrl: './claim-media.component.html',
  styleUrls: ['./claim-media.component.scss']
})
export class ClaimMediaComponent implements ITabComponent, OnInit {

  @Input() public mediaViewerUrl: string;

  constructor(
    private snackbarService: CrawfordSnackbarService
  ) { }

  ngOnInit() {
  }

  public loadData(): void {
    return;
  }

  public openMediaViewer(): void {
    if (this.mediaViewerUrl) {
      window.open(this.mediaViewerUrl, '_blank');
    } else {
      this.snackbarService.displayErrorMessage('No media viewer available for this claim');
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-media/claim-media.component.ts